import { render, staticRenderFns } from "./TcAppointmentFormSending.vue?vue&type=template&id=6d73df56&"
import script from "./TcAppointmentFormSending.vue?vue&type=script&lang=js&"
export * from "./TcAppointmentFormSending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d73df56')) {
      api.createRecord('6d73df56', component.options)
    } else {
      api.reload('6d73df56', component.options)
    }
    module.hot.accept("./TcAppointmentFormSending.vue?vue&type=template&id=6d73df56&", function () {
      api.rerender('6d73df56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcAppointmentFormSending.vue"
export default component.exports